/** Deutsch. See `en.ts` for what each key is and what it has to fit.
 *
 * The rail glyphs stay on the Latin WMO symbols; the pressure centers take
 * the German chart convention, H / T (Hoch / Tief). */

import type { MessageKey } from "./en";

export const de: Record<MessageKey, string> = {
  metaDescription:
    "Kostenlose Live-Wetterkarten im Browser: GFS-, ECMWF- und AIFS-Vorhersagen, Radar- und Satellitenloops, Taifunzugbahnen, 3D-Radar und Skew-T-Diagramme.",
  pageTitleLive: "{variable} – Vorhersagekarte · {model} {hours}H",
  pageTitleLiveObservation: "{variable} – Beobachtungskarte · {model} · letzte {hours} h",
  mapAria: "Globale Vorhersagekarte für Temperatur und Niederschlag",
  modelSwitchAria: "Datensatz",
  variableSwitchAria: "Meteorologische Größe",
  varTemp: "2M",
  varPrecip: "RATE",
  varWind: "10M",
  varSolar: "FLUSS",
  varRadar: "CREF",
  varOrog: "OROG",
  varInfrared: "IR 10,4",
  varShortwave: "IR 3,9",
  varDustRgb: "RGB",
  varDustCf: "DEBRA",
  varZhouye: "ZHOUYE",
  varTrueColor: "FARBE",
  varGust: "BÖEN",
  varCloud: "GESAMT",
  varCape: "BODEN",
  varPwat: "SÄULE",
  varPtype: "ART",
  varCin: "HEMMUNG",
  varHpbl: "HÖHE",
  varVis: "SICHT",
  varDewPoint: "2M",
  varFeelsLike: "2M",
  varOmega: "VERT",
  varThetaE: "ÄQUIV",
  varCat: "EDR",
  varInflow: "ZUFUHR",
  varFront: "FRONT",
  varHotspot: "BRANDHERD",
  varFfwi: "FEUERWETTER",
  varFwalert: "WARNUNG",
  varSst: "HAUT",
  varIce: "BEDECK.",
  varWave: "HÖHE",
  varAod: "GESAMT",
  varPm: "2.5",
  varDustsfc: "BODEN",
  varTsoil: "LAGE 1",
  varSoilw: "LAGE 1",
  varHumidity: "REL",
  varVapourFlux: "FLUSS",
  varPressure: "NN",
  varHeight: "HÖHE",
  varPressureField: "FELD",
  varUnknownLayer: "EBENE",

  glyphTmp2m: "T",
  glyphPrate: "R",
  glyphWind10m: "W",
  glyphDswrf: "S",
  glyphCref: "Z",
  glyphIr104: "I",
  glyphIr039: "K",
  glyphDustrgb: "S",
  glyphDustcf: "K",
  glyphZhouye: "Z",
  glyphTruecolor: "E",
  glyphGust: "G",
  glyphTcdc: "N",
  glyphCape: "C",
  glyphVis: "V",
  glyphPwat: "P",
  glyphCin: "I",
  glyphHpbl: "B",
  glyphPtype: "Y",
  glyphDpt2m: "D",
  glyphAptmp2m: "A",
  glyphVvel: "ω",
  glyphThetae: "θ",
  glyphCat: "ε",
  glyphInflow: "M",
  glyphFront: "F",
  glyphHotspot: "B",
  glyphFfwi: "F",
  glyphFwalert: "W",
  glyphTmpsfc: "S",
  glyphIce: "I",
  glyphWave: "H",
  glyphAod: "τ",
  glyphPm: "µ",
  glyphDustsfc: "S",
  glyphTsoil: "E",
  glyphSoilw: "M",
  glyphPressure: "P",
  glyphRh: "U",
  glyphQflux: "F",
  tipTemp: "Temperatur",
  tipHumidity: "Relative Feuchte",
  tipWind: "Wind",
  tipPressure: "Luftdruck und geopotentielle Höhe",
  tipVapourFlux: "Wasserdampffluss",
  tipCloud: "Bewölkung",
  tipOmega: "Vertikalgeschwindigkeit",
  tipThetaE: "Äquivalentpotentielle Temperatur",
  tipCat: "Klarluftturbulenz",
  tipIce: "Meereis",
  tipWave: "Seegang",
  tipAod: "Aerosol-optische Dicke",
  tipPm: "Feinstaub",
  tipTsoil: "Bodentemperatur",
  tipSoilw: "Bodenfeuchte",
  tipSatellite: "Satellitenbild",
  levelSwitchAria: "Niveau",
  levelCaption: "Niveau",
  linesCaption: "Linien",
  accumCaption: "Summe",
  accumRateGloss: "Rate",
  accumTotalGloss: "Summe {window}",
  modelHeading: "Datensätze",
  linesRemoveTitle: "Erneut drücken, um die Linien zu entfernen",
  fieldSectionAria: "Feld",
  overlaySectionAria: "Überlagerungen",
  markSectionAria: "Markierungen",
  tipMore: "Alle Ebenen dieses Laufs",
  varMore: "Ebenen",
  glyphMore: "+",
  fieldSheetAria: "Ebenen",
  fieldSheetHeading: "Ebenen",
  fieldGroupTemperature: "Temperatur",
  fieldGroupMoisture: "Feuchte",
  fieldGroupSoil: "Boden",
  fieldGroupWind: "Wind",
  fieldGroupDynamics: "Dynamik",
  fieldGroupRadiation: "Strahlung & Sicht",
  fieldGroupAerosol: "Aerosole & Luftqualität",
  fieldGroupOcean: "Ozean",
  fieldGroupHydrology: "Flüsse & Hochwasser",
  fieldGroupSatellite: "Satellit",
  fieldGroupOther: "Sonstige",
  fieldGroupImagery: "Tagesbilder: NASA GIBS",
  gibsTrueColor: "ECHT",
  gibsFalseColor: "FEUER",
  gibsTipTrue: "Echtfarben",
  gibsTipFire: "Brand-Falschfarben: Brandnarben dunkelrot",
  varParticles: "STRÖMUNG",
  glyphParticles: "≈",
  varVolume: "3D-WOLKE",
  glyphVolume: "Q",
  levelAlone: "Nur Linien",
  levelAloneTitle: "Nur die Linien: das Feld verschwindet, erneut drücken bringt es zurück",
  creditsTrigger: "Quellen",
  creditsHeading: "Daten & Dank",
  creditsGfs: "Vorhersagedaten: GFS 0.25° und sflux",
  creditsHrrr: "Vorhersagedaten: HRRR 3 km, kontinentale USA",
  creditsGefsAero: "Aerosolvorhersage: GEFS-Aerosols 0,25°, AOD und Feinstaub am Boden",
  creditsCmaDust: "Staubvorhersage: CMA-CW v1.0/DUST (WMO SDS-WAS Asian Center) 0,15° über Asien, über WMO WIS2",
  creditsSilam: "Luftqualitätsvorhersage: FMI SILAM v6.1 global 0,2°, CC BY 4.0",
  creditsCfs: "Saisonvorhersage: CFSv2, 9 Monate, 6-stündlich",
  creditsEcmwf: "Enthält veränderte ECMWF-Daten, CC BY 4.0",
  creditsIfsHres: "Angepasst aus ECMWF IFS von ECMWF, lizenziert unter CC BY 4.0; über Open-Meteo; IFS HRES ~9 km, auf 0,1° neu abgetastet",
  creditsMrms: "Radarbeobachtungen: MRMS, kontinentale USA",
  creditsNexrad: "Einzelradar: Reflektivität und Radialgeschwindigkeit, USA",
  creditsJma: "Radarniederschlag: JMA-Nowcast, Japan (umgerastert)",
  creditsHimawari: "Satellitenbilder: Himawari-9 AHI, JMA, über NOAA Open Data (umprojiziert)",
  creditsGoes: "Satellitenbilder: GOES-19 East & GOES-18 West ABI, NOAA NESDIS, über NOAA Open Data (umprojiziert)",
  creditsMeteosat: "Satellitenbilder: enthält modifizierte EUMETSAT-Meteosat-Daten {year}; Meteosat-12 FCI, stündlicher Zyklus, CC-BY-4.0 (umprojiziert)",
  creditsSounding: "Radiosondenaufstiege: GTS-TEMP über WIS2, nationale Wetterdienste",
  creditsAirport: "Flughafen-METAR & TAF: Wetterdienste weltweit über NOAA/NWS AWC",
  creditsFirms: "Aktive Feuer: LANCE FIRMS NRT, VIIRS 375 m und MODIS, NASA ESDIS",
  creditsGibs: "Tägliche Bilder: MODIS- und VIIRS-korrigierte Reflektanz, NASA ESDIS",
  creditsRadar: "Radarkomposit",
  creditsBasemap: "Basiskarte: © OpenStreetMap-Mitwirkende",
  creditsTerrain: "Geländerelief: © Mapterhorn, Höhendaten-Quellen",
  creditsPeaks: "Gipfelnamen & Höhen: CC0",
  creditsCode: "Quellcode: ringsaturn/xue",
  caseTag: "Fall",
  caseSummaryAria: "Fallbeschreibung",
  runCycle: "Modelllauf",
  recordSpan: "Zeitraum der Reihe",
  latestObservation: "Letzte Beobachtung",
  latestNowcast: "Letzter Nowcast",
  awaitingData: "Warte auf Daten",
  validTimeLabel: "Gültigkeitszeit",
  observationTimeLabel: "Beobachtungszeit",
  statsAria: "Statistik für Nerds",
  statsCloseAria: "Statistik schließen",
  bufferedFrames: "Gepuffert",
  downloadedBytes: "Geladen",
  formatLabel: "Format",
  formatZarr: "Zarr",
  preloadProgressAria: "Fortschritt beim Vorladen der Vorhersagedaten",
  statDataset: "Datensatz",
  statGrid: "Gitter",
  statFrameCache: "Bildpuffer",
  statDecodeTime: "Dekodierzeit",
  statDecodeRate: "Dekodierrate",
  statViewport: "Abtastung",
  statConnection: "Verbindung",
  awaitingManifest: "Warte auf Manifest",
  legendPrateAria: "Farbskala der Niederschlagsrate",
  timelineAria: "Zeitsteuerung der Vorhersage",
  playAnimation: "Animation abspielen",
  pauseAnimation: "Animation anhalten",
  playbackSpeed: "Abspielgeschwindigkeit",
  exportOpenAria: "Schleife exportieren",
  exportSheetAria: "Schleife exportieren",
  exportHeading: "Export",
  exportFormat: "Format",
  exportSize: "Größe",
  exportFps: "Bildrate",
  exportRange: "Bilder",
  exportFrom: "Von",
  exportTo: "Bis",
  exportRun: "Exportieren",
  exportCancel: "Abbrechen",
  exportSummary: "{size}, {frames} Bilder, {seconds} s, etwa {bytes}",
  exportCapturing: "Aufnahme {done}/{total}",
  exportEncoding: "Kodierung {percent} %",
  exportFailed: "Export fehlgeschlagen",
  readingManifest: "Manifest wird geladen",
  forecastHourAria: "Vorhersagestunde",
  forecastDaysAria: "Tägliche Vorhersageabschnitte",
  observationDaysAria: "Tägliche Abschnitte",
  mapMenuAria: "Kartenoptionen",
  menuStats: "Statistik für Nerds",
  menuCopyDebug: "Debug-Infos kopieren",
  errorTitle: "Daten nicht verfügbar",
  retry: "Erneut laden",
  langPickerAria: "Sprache",
  langPickerHeading: "Sprache",
  themeToggleAria: "Hell / dunkel umschalten",
  viewGlobeAria: "Globus",
  viewTerrainAria: "3D-Gelände",
  viewContoursAria: "Höhenlinien",
  viewResetNorthAria: "Nach Norden ausrichten",
  viewResetPitchAria: "Neigung zurücksetzen",
  viewBoxAria: "Sturm-Nahansicht: Rechteck aufziehen",
  viewSectionAria: "Vertikalschnitt: Linie ziehen",
  viewDistanceAria: "Strecke messen: Punkte anklicken, letzten erneut anklicken zum Beenden",
  viewAreaAria: "Fläche messen: Ecken anklicken, ersten oder letzten erneut anklicken zum Beenden",
  particlesToggle: "Partikel",
  particlesToggleAria: "Windpartikel-Animation umschalten",

  dataInterrupted: "Laden der Daten unterbrochen",
  errorHint: "{message}. Stelle sicher, dass make mvp gelaufen ist und die Seite über make serve ausgeliefert wird.",
  loadFailed: "Laden fehlgeschlagen",
  webglLost: "WebGL nicht verfügbar: Browser vollständig beenden und neu öffnen",
  saveData: "Sparmodus",
  debugCopied: "Debug-Infos kopiert",
  copyFailed: "Kopieren fehlgeschlagen",
  bundleResident: "Bündel vollständig gepuffert",
  viewportResident: "Sichtbereich vollständig gepuffert",
  streamingOnDemand: "Streaming nach Bedarf",
  receivingBundle: "Vorhersagebündel wird empfangen",
  receivingBundlePercent: "Bündel wird empfangen {percent}%",
  readingIndex: "Datenindex wird gelesen",
  initializingDecoder: "Dekoder wird initialisiert",
  framesReady: "{count} Bilder bereit",
  readingData: "Daten werden geladen",
  bundleLoadFailed: "Vorhersagebündel konnte nicht geladen werden",
  workerStartFailed: "Dekodier-Worker konnte nicht starten",
  decodeFailed: "Dekodieren fehlgeschlagen",
  frameDecodeFailed: "Bild konnte nicht dekodiert werden: {message}",
  legendAria: "Farbskala {label}",
  legendInflow: "Warm-feuchte Zufuhr",
  legendFront: "Frontalzone (θe-Gradient)",
  legendHotspot: "Brandherd (Kontexttest bei 3,9 µm)",
  legendFfwi: "Fosberg-Feuerwetterindex",
  legendFwalert: "Relative Feuchte unter 30 % bei Böen ab 10 m/s",
  legendDustDust: "Staub",
  legendDustThickHigh: "Dichte hohe Wolken",
  legendDustThinHigh: "Dünne hohe Wolken",
  legendDustMid: "Mittelhohe Wolken",
  legendDustLow: "Tiefe warme Wolken",
  legendDustDesert: "Heiße Wüstenoberfläche",
  legendDustSurface: "Meer und bewachsenes Land",
  legendTruecolorCloud: "Wolken und Schnee",
  legendTruecolorSea: "Meer",
  legendTruecolorLand: "Land und Vegetation",
  legendTruecolorNightCloud: "Wolken bei Nacht (Infrarot)",
  legendTruecolorNightGround: "Wolkenfrei bei Nacht",
  legendPtypeRain: "Regen",
  legendPtypeFreezingRain: "Gefrierender Regen",
  legendPtypeSnow: "Schnee",
  legendPtypeIcePellets: "Eiskörner",
  legendDisrpBelow: "Unter HQ1,5",
  legendDisrp1p5: "≥ HQ1,5",
  legendDisrp2: "≥ HQ2",
  legendDisrp5: "≥ HQ5",
  legendDisrp20: "≥ HQ20",
  legendCatLight: "Leicht",
  legendCatModerate: "Mäßig",
  legendCatModerateSevere: "Mäßig–schwer",
  legendCatSevere: "Schwer",
  varLabelTmp2m: "Temperatur in 2 m",
  varLabelPrate: "Niederschlagsrate",
  varLabelDswrf: "Sonneneinstrahlung",
  varLabelWind10m: "Wind in 10 m",
  varLabelWind80m: "Wind in 80 m",
  varLabelWind100m: "Wind in 100 m",
  varLabelCref: "Radar-Komposit-Reflektivität",
  varLabelRefl3d: "3D-Radarreflektivität",
  varLabelCloud3d: "3D-Wolkenwasser",
  varLabelOrog: "Orographie",
  varLabelIr104: "Infrarotbild (Helligkeitstemperatur bei 10,4 µm)",
  varLabelIr039: "Kurzwelliges Infrarot (Helligkeitstemperatur bei 3,9 µm)",
  varLabelDustrgb: "Staub-RGB (Infrarot-Komposit)",
  varLabelDustcf: "DEBRA-Staubkonfidenz",
  varLabelZhouye: "ZHOUYE-Staubkonfidenz",
  varLabelTruecolor: "Echtfarbe am Tag, Infrarot-Wolken bei Nacht",
  varLabelGust: "Windböen",
  varLabelTcdc: "Gesamtbedeckung",
  varLabelCape: "Konvektiv verfügbare potentielle Energie",
  varLabelCin: "Konvektive Hemmung",
  varLabelVis: "Sichtweite",
  varLabelDpt2m: "Taupunkt in 2 m",
  varLabelAptmp2m: "Gefühlte Temperatur in 2 m",
  varLabelLcdc: "Tiefe Bewölkung",
  varLabelMcdc: "Mittlere Bewölkung",
  varLabelHcdc: "Hohe Bewölkung",
  varLabelPwat: "Niederschlagbares Wasser",
  varLabelHpbl: "Höhe der planetaren Grenzschicht",
  varLabelPtype: "Niederschlagsart",
  varLabelTmpsfc: "Meeresoberflächentemperatur (über Land Oberflächentemperatur)",
  varLabelIcec: "Meereisbedeckung",
  varLabelIcetk: "Meereisdicke",
  varLabelWave: "Seegang: signifikante Wellenhöhe und Richtung",
  varLabelHtsgw: "Signifikante Wellenhöhe",
  varLabelPerpw: "Periode der Hauptwelle",
  varLabelDirpw: "Richtung der Hauptwelle",
  varLabelWindwave: "Windsee: signifikante Höhe und Richtung",
  varLabelSwell: "Dünung: signifikante Höhe und Richtung (erste Komponente)",
  varLabelWvhgt: "Signifikante Höhe der Windsee",
  varLabelWvper: "Mittlere Periode der Windsee",
  varLabelWvdir: "Richtung der Windsee",
  varLabelSwhgt: "Signifikante Höhe der Dünung (erste Komponente)",
  varLabelSwper: "Mittlere Periode der Dünung (erste Komponente)",
  varLabelSwdir: "Richtung der Dünung (erste Komponente)",
  varLabelAod: "Aerosol-optische Dicke bei 550 nm",
  varLabelAoddust: "Optische Dicke Staub",
  varLabelAodsalt: "Optische Dicke Seesalz",
  varLabelAodsulf: "Optische Dicke Sulfat",
  varLabelAodorg: "Optische Dicke organischer Kohlenstoff",
  varLabelAodbc: "Optische Dicke Ruß",
  varLabelPm25: "PM2,5-Konzentration am Boden",
  varLabelPm10: "PM10-Konzentration am Boden",
  varLabelPm10dust: "Staub-PM10-Konzentration am Boden",
  varLabelDustsfc: "Staubkonzentration am Boden",
  varLabelTsoil1: "Bodentemperatur, Schicht 1",
  varLabelTsoil2: "Bodentemperatur, Schicht 2",
  varLabelTsoil3: "Bodentemperatur, Schicht 3",
  varLabelTsoil4: "Bodentemperatur, Schicht 4",
  varLabelSoilw1: "Volumetrische Bodenfeuchte, Schicht 1",
  varLabelSoilw2: "Volumetrische Bodenfeuchte, Schicht 2",
  varLabelSoilw3: "Volumetrische Bodenfeuchte, Schicht 3",
  varLabelSoilw4: "Volumetrische Bodenfeuchte, Schicht 4",
  varLabelPrmsl: "Luftdruck auf Meeresniveau",
  varLabelHeightAtLevel: "Geopotentielle Höhe {level} hPa",
  varLabelTempAtLevel: "Temperatur {level} hPa",
  varLabelRhAtLevel: "Relative Feuchte {level} hPa",
  varLabelSpfhAtLevel: "Spezifische Feuchte {level} hPa",
  varLabelWindAtLevel: "Wind {level} hPa",
  varLabelQfluxAtLevel: "Wasserdampffluss {level} hPa",
  varLabelVvelAtLevel: "Vertikalgeschwindigkeit in {level} hPa",
  varLabelThetaeAtLevel: "Äquivalentpotentielle Temperatur in {level} hPa",
  varLabelCatAtLevel: "Klarluftturbulenz in {level} hPa (EDR)",
  legendSubtropicalHigh: "588er Linie",
  webglUnavailable: "Dieser Browser stellt keinen WebGL2-Kontext bereit",
  pointerRequestFailed: "Live-Zeiger-Anfrage lieferte HTTP {status}",
  manifestRequestFailed: "Manifest-Anfrage lieferte HTTP {status}",
  bundleRequestFailed: "Bündel-Anfrage lieferte HTTP {status}",
  bundleTooLong: "Bündel überschreitet die im Manifest angegebene Länge",
  bundleLengthMismatch: "Bündellänge stimmt nicht mit dem Manifest überein",
  bundleChecksumMismatch: "Prüfsumme des Bündels stimmt nicht",
  bundleRunMismatch: "Modelllauf des Bündels stimmt nicht mit dem Manifest überein",
  bundleMissingVariable: "Im Bündel fehlt die Größe {id}",
  manifestMissingBundle: "Das Manifest hat kein Bündel für die Größe {id}",
  mosaicNoMembers: "Kein Satellitendatensatz des Mosaiks ist verfügbar",

  probeAria: "Zeitreihe am Punkt",
  probeHint: "Abspielen oder scrubben, um die Reihe zu füllen",
  probeComplete: "Reihe vollständig",
  probeOutside: "Außerhalb des Gitters dieses Datensatzes",
  probeNoData: "Keine Daten in diesem Bild",
  probeAwaiting: "Warte auf dieses Bild",
  probeModelElevationLabel: "Modell",
  probeDemLabel: "DEM",
  probeCloseAria: "Punktdaten schließen",
  cardCloseAria: "Karte schließen",

  centerHigh: "H",
  centerLow: "T",

  showcaseLink: "Fälle",
  showcaseBack: "← Alle Fälle",
  showcaseHome: "Live-Vorhersage",
  showcaseTitle: "Wetterfälle",
  showcaseHeading: "Wetterlagen, noch einmal abgespielt",
  showcaseArchive: "Archiv",
  showcaseIntro:
    "Jeder Fall ist ein Ausschnitt aus einer vergangenen Wetterlage — ein archivierter Modelllauf oder Beobachtungen — durch denselben Encoder, zugeschnitten auf die Region und die Stunden, in denen sie stattfand.",
  showcaseMetaDescription:
    "Vergangene Wetterlagen im Rückblick: zugeschnittene Vorhersage- und Radardatensätze zu Taifunen, Starkregen, Hitzewellen und mehr",
  showcaseLoading: "Fallkatalog wird geladen",
  showcaseEmpty: "Noch keine Fälle veröffentlicht",
  showcaseLoadFailed: "Fallkatalog konnte nicht geladen werden: {message}",
  showcaseCaseMissing: "Kein Fall mit dem Namen {id}",
  showcaseEventLabel: "Ereignis",
  showcaseRunLabel: "Lauf",
  showcaseSeriesLabel: "Beginn",
  showcaseRangeLabel: "Vorlauf",
  showcaseSpanLabel: "Dauer",
  showcaseRegionLabel: "Region",
  showcaseGridLabel: "Gitter",
  showcaseSizeLabel: "Größe",
  showcaseVariablesLabel: "Größen",
  showcaseHours: "{count} h",
  showcaseCaseAria: "Fall {title} öffnen",
  showcaseListAria: "Liste der Wetterfälle",

  tcTileTip: "Tropische Wirbelstürme",
  varTc: "ZUGBAHN",
  glyphTc: "C",
  tcSheetAria: "Tropische Wirbelstürme",
  tcHeading: "Tropische Wirbelstürme",
  tcAllSystems: "Alle nummerierten Systeme",
  tcNone: "Keine aktiven Systeme",
  tcUnnamed: "Unbenanntes System",
  tcDisturbances: "Störungen und Tiefs",
  tcPotential: "Mögliche Systeme",
  tcPotentialShow: "{count} nur von Modellen gefundene Systeme zeigen",
  tcModelOnly: "nur Modell",
  tcAgencies: "Offizielle Vorhersagen",
  tcModels: "Modellzugbahnen",
  tcMembers: "Ensemble-Member",
  tcBest: "Best Track",
  tcOptionsAria: "Sturmoptionen",
  tcHistoryHeading: "Vergangene tropische Wirbelstürme",
  tcHistoryIntro: "Jeder nummerierte Sturm im Archiv: die Best Tracks der Zentren, jede für ihn erstellte Vorhersage und wie weit sie danebenlag.",
  tcHistorySeasonsAria: "Saison",
  tcHistoryBasinsAria: "Becken",
  tcHistoryAll: "Alle",
  tcHistoryEmpty: "Keine Stürme mit Vorhersagen in dieser Saison und diesem Becken",
  tcHistoryStormAria: "{name} öffnen",
  tcHistorySouthernNote: "Saisons auf der Südhalbkugel laufen von Juli bis Juni und tragen das Jahr, in dem sie enden: Die Saison {season} reicht von {from} bis {to}.",
  tcPageTitle: "Vergangener tropischer Wirbelsturm",
  tcPageMetaDescription: "Ein vergangener tropischer Wirbelsturm: die Best Tracks der Zentren, jede archivierte Vorhersage dafür und wie weit sie danebenlag.",
  tcPageLoading: "Sturm wird geladen",
  tcPageMissing: "Kein archivierter Sturm namens {id}",
  tcPageFailed: "Sturm konnte nicht geladen werden: {message}",
  tcPageIssue: "Zeitpunkt",
  tcPageNoForecast: "keine Vorhersage ab hier",
  tcPagePrev: "Frühere Vorhersage",
  tcPageNext: "Spätere Vorhersage",
  tcPageSources: "Angezeigte Zugbahnen",
  tcPageErrorsHeading: "Positionsfehler, km",
  tcPageTruth: "Verglichen mit dem Best Track von",
  tcPageSource: "Quelle",
  tcPageErrorsMean: "Mittel über den Sturm",
  tcPageErrorsThis: "Die Vorhersage auf der Karte",
  tcPageErrorsNone: "Noch keine Vorhersage dieses Sturms wurde mit diesem Best Track verglichen",
  tcPageNote: "Abstand zum Best Track zu den synoptischen Terminen, nur gezählt, solange das System ein tropischer oder subtropischer Wirbelsturm ist; ein Ensemble wird an seinem Mittel gemessen. Die offiziellen Vorhersagen stehen neben Modellen mit demselben Starttermin, die erst nach der offiziellen Vorhersage fertig wurden.",
  tcPageId: "ATCF-Kennung",
  tcPageLife: "Lebensdauer",
  tcPagePeak: "Spitzenwind",
  tcPageForecasts: "Vorhersagen",
  tcCardSeasons: "Saisons",
  tcCardStorms: "Stürme",
  tcPageDetails: "Sturmseite",
  tcPageSeasonList: "Alle Stürme der Saison",
  tcCardBrowse: "Nach Saison",
  tcPageRadii: "Windradien",
  tcLegendIntensity: "Intensität: US-Best-Track, 1-Minuten-Wind",

  soundingTileTip: "Radiosondenaufstiege",
  varSounding: "HÖHENLUFT",
  glyphSounding: "S",
  airportTileTip: "Flughafenbeobachtungen",
  varAirport: "METAR",
  glyphAirport: "A",
  synopTileTip: "Bodenwetterstationen",
  varSynop: "BODEN",
  glyphSynop: "W",
  radarTileTip: "Einzelradar",
  varRadarSite: "STANDORT",
  glyphRadarSite: "D",
  radarProductAria: "Radarprodukt",
  radarLatest: "neueste",
  radarCloseAria: "Zurück zum Komposit",
  radarReflectivity: "Reflektivität",
  radarVelocity: "Radialgeschw.",
  stationSounding: "Radiosondierung",
  stationAirport: "Flughafen",
  stationObserved: "Beobachtet",
  stationFreezingLevel: "Nullgradgrenze",
  stationPw: "Niederschlagbares Wasser",
  stationCategory: "Flugkategorie",
  stationVisibility: "Sichtweite",
  stationQnh: "QNH",
  stationLevels: "Niveaus",
  stationSynop: "Wetterstation",
  stationHumidity: "Luftfeuchte",
  stationPrecipitation: "Niederschlag",
  stationPressure: "Stationsdruck",
  stationSeaLevelPressure: "Luftdruck auf Meereshöhe",
  stationSunshine: "Sonnenschein",
  stationSnowDepth: "Schneehöhe",
  stationElevation: "Höhe",
  stationOpenSounding: "Sondierung öffnen",
  stationPinHere: "Hier anheften",
  fireTileTip: "Aktive Brände (NASA FIRMS, letzte 24 h)",
  varFire: "BRÄNDE",
  glyphFire: "F",
  fireDetection: "Aktiver Brand",
  fireAcquired: "Aufgenommen",
  fireRadiativePower: "Strahlungsleistung",
  fireBrightness: "Helligkeitstemperatur",
  fireConfidence: "Konfidenz",
  fireConfidenceLow: "niedrig",
  fireConfidenceNominal: "nominal",
  fireConfidenceHigh: "hoch",
  fireOverpass: "Überflug",
  fireDay: "Tag",
  fireNight: "Nacht",
  aqTileTip: "Luftqualitätsstationen (PM2.5)",
  varAq: "PM2.5",
  glyphAq: "Q",
  aqStation: "Luftqualität",
  aqAgency: "Betreiber",
  aqNetwork: "Netz",
  aqPreliminary: "Vorläufige Daten: nicht validiert, können sich ändern",
  aqDayRange: "PM2.5, letzte 24 h",
  aqNearest: "Nächste Luftqualitätsstation, {km} km",
  alertsTileTip: "Aktuell gültige Wetterwarnungen",
  varAlerts: "WARNUNGEN",
  glyphAlerts: "!",
  alertsCardTitle: "Warnungen",
  alertsInForceNow: "Jetzt gültig",
  alertsAsOf: "Stand {time}",
  alertsLevel: "Stufe {level}",
  alertsUntilCancelled: "bis zur Aufhebung",
  alertsIssued: "ausgegeben {time}",
  alertCategoryRain: "Starkregen",
  alertCategoryFlood: "Hochwasser",
  alertCategoryLandslide: "Erdrutsch",
  alertCategoryWind: "Wind",
  alertCategoryThunderstorm: "Gewitter",
  alertCategorySnowIce: "Schnee und Eis",
  alertCategoryHeat: "Hitze",
  alertCategoryCold: "Kälte",
  alertCategoryFog: "Nebel",
  alertCategoryDust: "Staub",
  alertCategoryFire: "Waldbrandgefahr",
  alertCategoryAir: "Luftqualität",
  alertCategoryCoastal: "Küste",
  alertCategoryMarine: "See",
  alertCategoryTsunami: "Tsunami",
  alertCategoryOther: "Sonstiges",
  markerPlace: "Ort",
  markerEvent: "Ereignis",
  markerSources: "Quellen",
  caseMarkersAria: "Orte und Ereignisse dieses Falls",
  casePartsAria: "Teile dieses Ereignisses",
  riverHeading: "Abfluss",
  riverTracksAria: "Modelllauf der Flüsse",
  riverTrackAnalysis: "Analyse",
  riverTrackForecast: "Vorhersage {cycle}",
  riverKeyAria: "Abfluss im Verhältnis zum üblichen",
  riverRatio2: "< 2× üblich",
  riverRatio10: "2–10×",
  riverRatio100: "10–100×",
  riverRatioMax: "≥ 100×",
  riverKeyField: "Nach Abfluss gefärbt, auf der Skala des Felds",
  riverExtents: "Überflutungsflächen",
  riverGaugeHint: "Kreise sind Pegel: anklicken für die Ganglinie.",
  riverObserved: "gemessen",
  riverModelled: "Modell",
  riverPeaks: "Gemeldete Scheitel",
  riverGaugeLoading: "lädt…",
  riverGaugeUnavailable: "nicht verfügbar",

  soundingObserved: "BEOB",
  soundingModel: "MODELL",
  soundingNoModel: "kein Modell binnen 12 h",
  soundingLoading: "Aufstieg wird gelesen…",
  soundingUnavailable: "Aufstieg nicht verfügbar",
  soundingExpand: "Gesamtes Diagramm",
  soundingClose: "Schließen",
  soundingSheetHeading: "Radiosonde",
  soundingSheetAria: "Radiosondendiagramm",

  // The comparison page (compare.html).
  compareLink: "Vergleich",
  compareTitle: "Vorhersagen vergleichen",
  compareHeading: "Modellvergleich",
  compareEyebrow: "Punkt",
  compareIntro:
    "Jedes laufende Vorhersagemodell an einem Punkt, auf einer Zeitachse: was jeder Lauf für die kommenden Stunden sagt, neben den Meldungen des nächstgelegenen Flughafens.",
  compareMetaDescription:
    "Vorhersagen von GFS, ECMWF, AIFS, IFS HRES und HRRR an einem Punkt Stunde für Stunde vergleichen, neben den METAR-Meldungen des nächstgelegenen Flughafens.",
  compareLatitude: "Breite",
  compareLongitude: "Länge",
  compareLocate: "Meinen Standort verwenden",
  compareLocateFailed: "Standort nicht verfügbar",
  compareOnMap: "Auf der Karte",
  compareSpan5: "5 Tage",
  compareSpan15: "15 Tage",
  compareFieldsAria: "Zu vergleichende Größen",
  compareModelsAria: "Modellvergleichsblöcke",
  compareLoading: "{model} wird gelesen…",
  compareModelFailed: "{model}: {message}",
  compareOffGrid: "außerhalb des Gitters dieses Modells",
  compareNoModels: "Kein Modell deckt diesen Punkt ab",
  compareHide: "Ausblenden",
  compareShow: "Einblenden",
  comparePin: "Nach oben heften",
  compareHidden: "Ausgeblendete Modelle",
  compareRun: "Lauf",
  compareObservationsFrom: "Meldungen von {icao}",
  compareNoAirport: "Kein Flughafen im Umkreis von 40 km",
  compareHours: "Stunden",
  compareNow: "jetzt",
  compareCells: "Jeder Wert ist die dem Punkt nächste Gitterzelle des jeweiligen Modells, nie eine Interpolation; Zeiten in Ihrer Zeitzone.",
  metricsMetaDescription: "Wann jeder Xue-Vorhersagelauf live ging, gemessen aus den Veröffentlichungs-Workflows: Latenz nach dem Zyklustermin, fehlende Zyklen und was zum ERCOT-Day-Ahead-Schluss live war.",
  metricsHeading: "Laufankunft",
  metricsEyebrow: "gemessen",
  metricsIntro: "Wann jeder Vorhersagelauf auf dieser Seite live ging, aus den eigenen Aufzeichnungen der Veröffentlichungs-Workflows: der Moment, in dem der Live-Zeiger geschrieben wurde, und wie lange nach dem Zyklustermin des Modells das war.",
  metricsNotSla: "Dies sind Messungen, kein Service-Level: Xue sagt keine Verfügbarkeit zu.",
  metricsGenerated: "Erstellt {time}, letzte {days} Tage",
  metricsLoading: "Metriken werden gelesen…",
  metricsEmpty: "Noch keine Metriken. Sie werden alle sechs Stunden aus den Veröffentlichungs-Workflows erstellt; schauen Sie nach dem nächsten Lauf wieder vorbei.",
  metricsFailed: "Metriken konnten nicht gelesen werden: {message}",
  metricsSourcesHeading: "Nach Quelle",
  metricsLatencyNote: "Die Latenz reicht vom Zyklustermin bis zu dem Moment, in dem der Lauf live ging, und schließt damit die Rechenzeit des Modells selbst ein. Alle Zeiten in UTC.",
  metricsTimelineNote: "Jeder Streifen ist das Zeitfenster: ein Balken je live gegangenem Zyklus, an seinem Zyklustermin, seine Höhe die Latenz gegenüber der längsten der Quelle; eine Marke unter der Linie ist ein Zyklus, der nie ankam.",
  metricsTypicalNote: "* Typisch upstream: ein Erfahrungswert, wann die Daten des Modells nach dem Zyklustermin üblicherweise vollständig sind, keine Messung. Leer, wo es keinen gibt.",
  metricsTimelineAria: "{model}-Ankünfte im Zeitfenster",
  metricsCadence: "alle {hours} h",
  metricsLatest: "Letzter Lauf",
  metricsLanded: "Live um",
  metricsLatency: "Latenz",
  metricsMedian: "Median",
  metricsMax: "Max",
  metricsTypical: "Typisch upstream",
  metricsCycles: "Angekommene Zyklen",
  metricsMissing: "Fehlend",
  metricsMissingList: "Fehlende Zyklen",
  metricsRuns: "Workflow-Läufe",
  metricsOutcomeLanded: "live",
  metricsOutcomeSkipped: "übersprungen",
  metricsOutcomeDryRun: "Probelauf",
  metricsOutcomeFailed: "fehlgeschlagen",
  metricsBacklog: "{count} Workflow-Läufe noch nicht gelesen; der nächste Lauf liest sie.",
  metricsDeadlinesHeading: "Zum Stichtag",
  metricsDeadlineIntro: "Für jeden lokalen Tag der neueste Lauf, der zum Stichtag schon live war, und wie alt sein Zyklus da war.",
  metricsSource: "Quelle",
  metricsCommonest: "Meist",
  metricsNoneLive: "keiner",
  glyphAurora: "A",
  varAurora: "WAHR",
  varDis06: "6H",
  varDisrp: "RP",
  varUpstream: "FLÄCHE",
  fieldGroupSpace: "Weltraumwetter",
  fieldGroupFire: "Feuer",
  modelGroupForecast: "Vorhersagemodelle",
  modelGroupRadar: "Radar",
  varLabelAurora: "Wahrscheinlichkeit sichtbarer Polarlichter",
  varLabelDis06: "Abfluss (6-h-Mittel)",
  varLabelDisrp: "Jährlichkeitsklasse",
  varLabelUpstream: "Einzugsgebietsfläche",
  creditsAurora: "Weltraumwetter: Polarlichtwahrscheinlichkeit, NOAA SWPC OVATION-Modell",
  creditsEfas: "Abfluss: Copernicus EMS EFAS v5, Europa 1′; nur Fallstudien",
  creditsEra5: "Reanalyse: Copernicus C3S ERA5 (ECMWF), global 0,25°, stündlich, CC-BY-4.0; nur Fallstudien",
  creditsCams: "Aerosolanalyse: Copernicus CAMS (ECMWF), global 0,4°, dreistündlich, CC-BY-4.0; nur Fallstudien",
};
